module.exports = __webpack_public_path__ + "static/media/basketball.1a4fc6b7.svg";